import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "tagName"];
import { jsx as _jsx } from "react/jsx-runtime";
function AbstractElement(_ref) {
  let {
      children,
      tagName = 'span'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const Tag = tagName;
  return /*#__PURE__*/_jsx(Tag, Object.assign({}, rest, {
    children: children
  }));
}
AbstractElement.displayName = 'AbstractElement';
export default AbstractElement;